import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { NavLink as ActiveRouterLink, Link as RouterLink } from 'react-router-dom'
import { isSEOPage as checkIfSEOPage } from 'common/helpers'

import Message from 'components/text/Message/Message'


const Href = (props, { store }) => {
  const {
    className, children, title, messageName, to, toOLD, redirect, mailto,
    withHtmlTitle, onlyActiveOnIndex, activeClassName, _ref, dataTestId, ...rest
  } = props

  let isActive = false

  // fix for 404 page
  if (store && typeof store.getState === 'function' && typeof to === 'string') {
    const { routing: { location: { pathname, search } } } = store.getState()
    const [ toPath, toSearch = '' ] = to.split('?')

    isActive = pathname === toPath && search.includes(toSearch)
  }

  // monkey patch for SEO client side page to replace `to` with `toOLD`
  const isSEOPage = checkIfSEOPage(window.location.pathname)

  const isReactLink           = !isSEOPage && typeof to !== 'undefined'
  const isHrefLink            = (isSEOPage && typeof to !== 'undefined') || typeof toOLD !== 'undefined'
  const isHrefTargetBlankLink = typeof redirect !== 'undefined'
  const isSpanLink            = isReactLink || isHrefLink
    ? isActive && onlyActiveOnIndex
    : !to && !toOLD && !redirect && !mailto

  let content = children

  if (title) {
    content = (
      <Message text={title} messageName={messageName} html={withHtmlTitle} />
    )
  }

  if (isSpanLink) {
    const { onClick, onKeyDown, ...otherProps } = rest

    return (
      <span
        className={cx(className, { [activeClassName]: isActive })}
        ref={_ref}
        tabIndex="0"
        role="link"
        data-testid={dataTestId}
        {...otherProps}
        onClick={(e) => {
          if (onClick) {
            onClick(e)
          }
        }}
        onKeyDown={(e) => {
          if (onKeyDown) {
            onKeyDown(e)
          }

          if (e.key === 'Enter' && onClick) {
            onClick(e)
          }
        }}
      >
        {content}
      </span>
    )
  }

  if (isReactLink) {
    const reactLinkProps = {
      className,
      to,
      ...rest,
      children: content,
    }

    if (activeClassName) {
      return (
        <ActiveRouterLink
          placement="Href"
          activeClassName={activeClassName}
          isActive={(match, location) => `${location.pathname}${location.search}` === to}
          innerRef={_ref}
          data-testid={dataTestId}
          {...reactLinkProps}
        />
      )
    }

    return (
      <RouterLink data-testid={dataTestId} innerRef={_ref} {...reactLinkProps} />
    )
  }

  if (isHrefLink) {
    const url = `/${(to || toOLD).replace(/^\//, '')}`

    return (
      <a
        className={className}
        data-testid={dataTestId}
        href={url}
        rel="noopener noreferrer nofollow"
        ref={_ref}
        {...rest}
      >
        {content}
      </a>
    )
  }

  if (isHrefTargetBlankLink) {
    return (
      <a
        className={className}
        data-testid={dataTestId}
        href={redirect}
        target="_blank"
        rel="noopener noreferrer nofollow"
        ref={_ref}
        {...rest}
      >
        {content}
      </a>
    )
  }

  if (typeof mailto !== 'undefined') {
    return (
      <a
        className={className}
        href={`mailto:${mailto}`}
        data-testid={dataTestId}
        ref={_ref}
        {...rest}
      >
        {content || mailto}
      </a>
    )
  }
}

Href.propTypes = {
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  messageName: PropTypes.string,
  to: PropTypes.string,
  redirect: PropTypes.string,
  mailto: PropTypes.string,
  withHtmlTitle: PropTypes.bool,
}

Href.defaultProps = {
  withHtmlTitle: false,
}

Href.contextTypes = {
  store: PropTypes.object,
}


export default Href
